import React, { FC } from 'react';

import { SocialIcons } from 'app/design-system/components/SocialIcons';
import { useTranslation } from 'app/lang';
import type { SocialIconsNames } from 'app/packages/brand/get-socials/type';
import { Entries } from 'app/types/tsHelpers';

import dictionary from './SocialIcons.dictionary.json';

import styles from './SocialIcons.module.scss';

type SocialIconsProps = {
  socialIcons: SocialIconsNames;
};

const SocialIconsContent:FC<SocialIconsProps> = ({ socialIcons }) => {
  const { t } = useTranslation();

  const socialIconEntries = Object.entries(socialIcons) as Entries<typeof socialIcons>;

  return (
    <div className={styles.socialBlock}>
      <p>{t(dictionary.title)}</p>

      <ul className={styles.iconMenuList}>
        {
          socialIconEntries.map(([socialName, socialUrl]) => (
            <li key={socialUrl}>
              <a className={styles.iconItemLink}
                 href={socialUrl}
                 data-ga-event="footer-social"
                 data-ga-event-value={socialName}
                 target="_blank"
                 rel="noopener noreferrer">
                <SocialIcons socialName={socialName} />
              </a>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default SocialIconsContent;
